import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const ScrollToTopButton = () => {
	const [isVisible, setIsVisible] = useState(false);

	// Show button when page is scrolled down
	useEffect(() => {
		const toggleVisibility = () => {
			setIsVisible(window.scrollY > 200);
		};

		window.addEventListener('scroll', toggleVisibility);
		return () => window.removeEventListener('scroll', toggleVisibility);
	}, []);

	// Scroll to the top of the page
	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	};

	return (
		<div>
			{isVisible && (
				<button
					onClick={scrollToTop}
					className='fixed bottom-6 right-6 bg-[#87152B] text-white p-3 rounded-full shadow-lg hover:bg-[#AC9961] transition duration-300'
				>
					<FaArrowUp size={20} />
				</button>
			)}
		</div>
	);
};

export default ScrollToTopButton;
